import api from './axios';

const list = async () => {
  try {
    const { data } = await api.get('mcare-artemis-advertising-delivery/events');
    return data;
  } catch (error) {
    if (!error.response) {
      throw error;
    }
    throw error.response.data ? error.response.data : error.response;
  }
};

export default {
  list,
};
